/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Acquire_AssetInputs */

const en_acquire_asset = /** @type {(inputs: Acquire_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquire Asset`)
};

const es_acquire_asset = /** @type {(inputs: Acquire_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adquirir activo`)
};

const fr_acquire_asset = /** @type {(inputs: Acquire_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquérir le bien`)
};

const de_acquire_asset = /** @type {(inputs: Acquire_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asset erwerben`)
};

const ja_acquire_asset = /** @type {(inputs: Acquire_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アセットを取得`)
};

const zh_acquire_asset = /** @type {(inputs: Acquire_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收购资产`)
};

const ar_acquire_asset = /** @type {(inputs: Acquire_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحصول على الأصل`)
};

const id_acquire_asset = /** @type {(inputs: Acquire_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan Aset`)
};

const it_acquire_asset = /** @type {(inputs: Acquire_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquisisci Risorsa`)
};

const ru_acquire_asset = /** @type {(inputs: Acquire_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приобрести актив`)
};

const pt_acquire_asset = /** @type {(inputs: Acquire_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adquirir Ativo`)
};

const ko_acquire_asset = /** @type {(inputs: Acquire_AssetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`에셋 획득하기`)
};

/**
* | output |
* | --- |
* | "Acquire Asset" |
*
* @param {Acquire_AssetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const acquire_asset = /** @type {((inputs?: Acquire_AssetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Acquire_AssetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_acquire_asset(inputs)
	if (locale === "es") return es_acquire_asset(inputs)
	if (locale === "fr") return fr_acquire_asset(inputs)
	if (locale === "de") return de_acquire_asset(inputs)
	if (locale === "ja") return ja_acquire_asset(inputs)
	if (locale === "zh") return zh_acquire_asset(inputs)
	if (locale === "ar") return ar_acquire_asset(inputs)
	if (locale === "id") return id_acquire_asset(inputs)
	if (locale === "it") return it_acquire_asset(inputs)
	if (locale === "ru") return ru_acquire_asset(inputs)
	if (locale === "pt") return pt_acquire_asset(inputs)
	return ko_acquire_asset(inputs)
});